import http from './httpService';
import { API_ROOT } from '../config';
import Utils from '../utilities';

//const API_ROOT = process.env.REACT_APP_API_ROOT;
class KpiService {
  // cohorts
  getAllCohorts() {
    return http.get(`${API_ROOT}listKpiCohort/`);
  }
  createCohorts(cohorts) {
    return http.post(`${API_ROOT}kpiCohort/`, cohorts);
  }
  updateCohorts(cohorts) {
    return http.put(`${API_ROOT}kpiCohort/`, cohorts);
  }
  deleteCohorts(cohortId) {
    return http.patch(`${API_ROOT}kpiCohort/`, cohortId);
  }

  // metrics
  getAllMetrics() {
    return http.get(`${API_ROOT}listKpiMetrics/`);
  }
  createMetrics(metrics) {
    return http.post(`${API_ROOT}kpiMetrics/`, metrics);
  }
  updateMetrics(metrics) {
    return http.put(`${API_ROOT}kpiMetrics/`, metrics);
  }
  deleteMetrics(metricId) {
    return http.patch(`${API_ROOT}kpiMetrics/`, metricId);
  }

  // parameters - LC-723 Parameterized SQL Queries
  getAllParameters() {
    return http.get(`${API_ROOT}listParameters/`);
  }
  getParameterById(parameterId) {
    return http.post(`${API_ROOT}parameterById/`, parameterId);
  }
  createParameters(parameters) {
    return http.post(`${API_ROOT}parameter/`, parameters);
  }
  updateParameters(parameters) {
    return http.put(`${API_ROOT}parameter/`, parameters);
  }
  deleteParameters(parameterId) {
    return http.patch(`${API_ROOT}parameter/`, parameterId);
  }

  // KPI tree
  listPublishedTrees(data) {
    return http.post(`${API_ROOT}listKpiHomeTree/`, data);
  }

  listSavedTrees(data) {
    return http.post(`${API_ROOT}kpiTrees/`, data);
  }

  getTreeNodes(treeId) {
    return http.get(`${API_ROOT}kpiTree/${treeId}`);
  }

  setTreeData(data, isNew) {
    if (isNew) {
      return http.post(`${API_ROOT}kpiTree`, data);
    } else {
      return http.put(`${API_ROOT}kpiTree`, data);
    }
  }

  deleteTreeData(treeId) {
    return http.delete(`${API_ROOT}kpiTree/${treeId}`);
  }

  getCalculateTreeData(treeId) {
    return http.get(`${API_ROOT}kpiTreeNodes/${treeId}`);
  }

  setCalculateTreeData(data) {
    return http.post(`${API_ROOT}kpiTreeNodes/`, data);
  }

  getTreeNodeCohorts(data) {
    return http.post(`${API_ROOT}cohortOutput/`, data);
  }

  getCalculatedTreeList() {
    return http.get(`${API_ROOT}listCalculatedTree/`);
  }

  getFilteredAnalysis(data) {
    return http.post(`${API_ROOT}displayCalculatedTree/`, data);
  }

  getKPITreeFilter(treeID) {
    return http.get(`${API_ROOT}listAggDataFilter/${treeID}/`);
  }

  getAnamoliesData(data) {
    return http.post(`${API_ROOT}cohorteChart/`, data);
  }

  listCohortDriven() {
    return http.get(`${API_ROOT}cohortDriven/`);
  }

  getFiltersForKPI() {
    return http.get(`${API_ROOT}treeFilterAll/`);
  }

  getSequence() {
    return http.get(`${API_ROOT}getSequence/`);
  }

  // by App provider
  getKPIsByDomain(path) {
    return http.get(API_ROOT + path);
  }

  getAssetClassCount(assetClass) {
    return http.get(`${API_ROOT}kpiTree/domainCount?domain=${assetClass}`);
  }

  // Groups List
  getAllGroups() {
    return http.get(`${API_ROOT}kpiGroupNames/`);
  }

  // Templates List
  getAllTemplates() {
    return http.get(`${API_ROOT}templateNames/`);
  }

  // Connections List
  getAllConnections() {
    return http.get(`${API_ROOT}connectionNames/`);
  }

  // Trigger Aggregation Job
  setAggregationData(treeId) {
    //LC-1621
    return http.get(`${API_ROOT}kpiTree/trigger_aggregation/${treeId}`);
  }

   // Clone Tree API
   cloneKPITree(treeId) {
    return http.get(`${API_ROOT}kpiTree/clone?kpiTreeId=${treeId}`);
  }

}

export default new KpiService();